import { Configs } from "./Configs";
import { vismaSignOriginalMethods } from "../codegen";

/**
 * Business logic relating to Onboarding process and Digital signature.
 */
export class OnboardingLogic {

  /** Gets the authentication methods for digital signature. */
  public static getTupasMethods(): Array<{
    /** Identifier */
    id: string,
    /** Title that can be shown to user */
    title: string,
    /** Method image (bank logo) */
    img: string,
    /** True, if the method is considered being one of the most popular (Nordea, OP etc.) */
    isPopular: boolean,
  }> {

    const cdn = "https://cdn.salaxy.com/img";

    const imageOverrides = [
      "op",
      "nordea",
      "danske",
      "spankki",
      "handelsbanken",
      "mobiilivarmenne",
      "aktia",
      "pop",
      "sp",
      "omasp",
      "alandsbanken",
    ];

    const result = vismaSignOriginalMethods.map((v, i) => {
      return {
        id: v.identifier,
        title: v.name,
        img: imageOverrides[i] ? `${cdn}/salaxy/sign/${imageOverrides[i]}.png` : v.image,
        isPopular: i < 3,
      };
    });

    if (Configs.current?.isTestData)
    {
      result.splice(2, 0, {
        id: "tupas-tbank",
        img: `${cdn}/salaxy/sign/test-tbank.png`,
        isPopular: true,
        title: "Testing ID"
      });
      result[3].isPopular = false; // Replace Danske in popular list with test identification.
    }

    return result;
  }

  /**
   * Gets the new version of authentication methods by Telia.
   * @returns Array of euthentication methods.
   */
  public static getTeliaMethods(): Array<{
    /** Identifier */
    id: string,
    /** Title that can be shown to user */
    title: string,
    /** Method image (bank logo) */
    img: string,
     /** True, if the method is considered being one of the most popular (Nordea, OP etc.) */
     isPopular: boolean,
  }> {
    const methods = [
      { img: "https://cdn.salaxy.com/img/salaxy/sign/op.png", id: "saml.op.1", title: "Osuuspankki", isPopular: true },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png", id: "oidc.nordea.1", title: "Nordea" , isPopular: true },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/danske.png", id: "oidc.danskebank.1", title: "Danske Bank", isPopular: true  },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/spankki.png", id: "oidc.spankki.1", title: "S-Pankki", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/handelsbanken.png", id: "oidc.handelsbanken.1", title: "Handelsbanken", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/mobiilivarmenne.png", id: "mpki.telia.1", title: "Mobiilivarmenne", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/aktia.png", id: "oidc.aktia.1", title: "Aktia", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/pop.png", id: "oidc.pop.1", title: "POP Pankki", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/sp.png", id: "oidc.sp.1", title: "Säästöpankki", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/omasp.png", id: "oidc.omasp.1", title: "Oma Säästöpankki", isPopular: false },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/alandsbanken.png", id: "oidc.alandsbanken.1", title: "Ålandsbanken", isPopular: false },
    ];
    if (Configs.current?.isTestData) {
      methods.unshift( { img: "https://cdn.salaxy.com/img/salaxy/sign/test-tbank.png", id: "TEST", title: "Testi", isPopular: true });
    }
    return methods;
  }

}
